import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { colors, gradients } from "style";
import { FormattedMessage } from "react-intl";

/**
 * UploadProgress
 *
 * @param {number}  progress
 * @param {string}  textId
 * @param {object}  textIdValues
 * @param {boolean} overlay
 */
const UploadProgress = ({ progress = 0, textId = "Form.UploadProgress.Uploading", textIdValues, overlay = false }) => {
  return (
    <div css={[styles.wrapper, overlay && styles.overlay]}>
      <div css={styles.container}>
        <div css={styles.text}>
          <FormattedMessage id={textId} values={textIdValues} />
        </div>

        <div css={styles.progressBar}>
          <div css={styles.progressFill(progress)} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: css`
    width: 100%;
    display: flex;
    justify-content: center;
  `,
  overlay: css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    pointer-events: none;
  `,
  container: css`
    width: 80%;
    max-width: 340px;
    padding: 16px;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  `,
  text: css`
    color: ${colors.white};
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  `,
  progressBar: css`
    width: 100%;
    height: 8px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    overflow: hidden;
  `,
  progressFill: (progress) => css`
    height: 100%;
    width: ${progress}%;
    border-radius: inherit;
    background: ${gradients.missionLinearGradient};
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    transition: width 0.2s ease;
  `,
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "200% 0" },
    "100%": { backgroundPosition: "-200% 0" },
  },
};

UploadProgress.propTypes = {
  progress: PropTypes.number,
  textId: PropTypes.string,
  textIdValues: PropTypes.object,
  overlay: PropTypes.bool,
};

export default UploadProgress;
